import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Trophy, Users, Clock } from "lucide-react";

export default function PublicTeams() {
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    const loadTeams = async () => {
      const club = await api.get("/public/clubs/by-name/ASSMBB");
      const response = await api.get(`/public/clubs/${club.data.id}/teams`);
      const data = Array.isArray(response.data) ? response.data : response.data.items || response.data.teams || [];
      setTeams(data);
    };
    loadTeams();
  }, []);

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
      <div className="text-xs uppercase tracking-[0.3em] text-orange-500 font-bold mb-3">
        Catégories
      </div>
      <h1 className="font-display text-4xl lg:text-5xl font-black mb-4">Nos équipes</h1>
      <p className="text-slate-600 mb-10 max-w-3xl">
        Découvrez les catégories du club, des jeunes jusqu’aux équipes seniors.
      </p>

      {teams.length === 0 ? (
        <div className="text-slate-500">Aucune équipe à afficher.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {teams.map((t) => (
            <div key={t.id} className="bg-white border border-slate-200 rounded-2xl overflow-hidden hover:shadow-lg transition">
              <div className="h-44 bg-slate-100 flex items-center justify-center">
                <Trophy className="w-14 h-14 text-orange-400" />
              </div>

              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="bg-orange-100 text-orange-700 text-xs font-bold rounded-full px-3 py-1">
                    {t.category}
                  </span>
                  <span className="bg-slate-100 text-slate-600 text-xs font-bold rounded-full px-3 py-1">
                    {t.gender === "M" ? "Garçons" : t.gender === "F" ? "Filles" : "Mixte"}
                  </span>
                </div>

                <h3 className="font-display text-xl font-bold">{t.name}</h3>

                <div className="mt-4 space-y-2 text-sm text-slate-600">
                  <div className="flex items-center gap-2">
                    <Users className="w-4 h-4 text-orange-500" />
                    Coach : {t.coach_name || "À confirmer"}
                  </div>
                  <div className="flex items-center gap-2">
                    <Clock className="w-4 h-4 text-orange-500" />
                    Entraînement : {t.training_schedule || "À confirmer"}
                  </div>
                </div>

                {t.description && <p className="text-sm text-slate-600 mt-4">{t.description}</p>}

                <button className="mt-5 w-full bg-slate-900 text-white rounded-xl py-2.5 font-semibold hover:bg-orange-500 transition">
                  Voir l’équipe
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
